import { BaseSelect } from '@app/components';
import { userApi } from '@app/store';
import { createColumnHelper } from '@tanstack/react-table';
import { IUser } from '@app/common';
import React from 'react';
import { ResourceSelect, ResourceSelectParentProps } from '../ResourceSelect';

const columnHelper = createColumnHelper<IUser>();

const columns = [
  columnHelper.accessor('lastname', {
    header: () => (
      <BaseSelect.ListHeaderItem width="40%">
        Nom
      </BaseSelect.ListHeaderItem>
    ),
    cell: (info) => (
      <BaseSelect.ListItemCol width="40%">
        <BaseSelect.ListItemText numberOfLines={1} bold>
          {info.getValue()}
        </BaseSelect.ListItemText>
      </BaseSelect.ListItemCol>
    ),
  }),
  columnHelper.accessor('firstname', {
    header: () => (
      <BaseSelect.ListHeaderItem width="40%">
        Prénom
      </BaseSelect.ListHeaderItem>
    ),
    cell: (info) => (
      <BaseSelect.ListItemCol width="40%">
        <BaseSelect.ListItemText numberOfLines={1} bold>
          {info.getValue()}
        </BaseSelect.ListItemText>
      </BaseSelect.ListItemCol>
    ),
  }),
  columnHelper.accessor('email', {
    header: () => (
      <BaseSelect.ListHeaderItem width="20%">
        Email
      </BaseSelect.ListHeaderItem>
    ),
    cell: (info) => (
      <BaseSelect.ListItemCol width="20%">
        <BaseSelect.ListItemText numberOfLines={1}>
          {info.getValue()}
        </BaseSelect.ListItemText>
      </BaseSelect.ListItemCol>
    ),
  }),
];

export const UserSelect = ({ label = 'Utilisateur', ...props }: ResourceSelectParentProps<IUser>) => {
  return (
    <ResourceSelect
      label={label}
      columns={columns}
      nameKey='lastname'
      useQuery={userApi.useReadManyUsersQuery}
      selectedColumns={columns}
      {...props} />
  );
};

